import { ENDPOINT_ONBOARDING_GOAL } from "@constants/urls";
import axios from "@helpers/lib/axios";

export async function getGoal(key: string) {
	const { data } = await axios.get(
		`${ENDPOINT_ONBOARDING_GOAL}?key=${encodeURIComponent(key)}`,
	);

	return data.goal;
}

export async function setGoal(request: {
	key: string;
	goal: string;
}) {
	const { data } = await axios.post(ENDPOINT_ONBOARDING_GOAL, request);

	return data;
}
